<template>
  <p-o-d-10-2023-any-object-report></p-o-d-10-2023-any-object-report>
</template>

<script>
import POD102023AnyObjectReport from "@/components/ecologist/reports/POD-10/POD-10Report-2023AnyObject";
export default {
  name: "POD-10-2023AnyObjectView",
  components: { POD102023AnyObjectReport },
};
</script>

<style scoped></style>
